/* Customer Portal auth context — separate from the staff AuthContext.
   Uses a different backend cookie (portal_access_token) so a browser can be
   logged in as both a dispatcher and a customer at the same time. */
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);      // null = loading, false = logged out, object = signed in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/portal/auth/me");
      setUser(r.data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await api.post("/portal/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/portal/auth/register", payload);
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/portal/auth/logout"); } catch (_) {}
    setUser(false);
  };

  return (
    <PortalAuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used inside PortalAuthProvider");
  return ctx;
}
